import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/chang/Desktop/mj-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { HappyBox } from '../../doc-comps';
import BasicDemo from './demo/1-demo-basic';
import BasicDemoCode from '!raw-loader!./demo/1-demo-basic.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "alert-警告提示"
    }}>{`Alert 警告提示`}</h1>
    <p>{`警告提示，展现需要关注的信息。`}</p>
    <h2 {...{
      "id": "代码演示"
    }}>{`代码演示`}</h2>
    <h3 {...{
      "id": "基本用法"
    }}>{`基本用法`}</h3>
    <HappyBox code={BasicDemoCode} title="基本用法" desc="使用kind控制Alert类型" mdxType="HappyBox">
  <BasicDemo mdxType="BasicDemo" />
    </HappyBox>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`kind`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`警告类型`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'info'/'positive'/'negative'/'warning'非必填`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'info'`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      